import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Event as EventIcon,
  Group as GroupIcon,
  ExitToApp as ExitToAppIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";

import { Link } from "react-router-dom";

const drawerWidth = 240;

const AdminLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerCollapse = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawer = (
    <div>
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src="/khasdar.jpg"
          alt="Logo"
          style={{ height: "120px", width: "120px" }}
        />
      </Toolbar>

      {/* <Toolbar style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src="/khasdar.jpg" alt="Logo" style={{ height: "100px", width: "100px", marginBottom: "8px" }} />
                <Typography variant="h6" noWrap>
                    Khasdar Mahotsav
                </Typography>
            </Toolbar> */}

      <List>
        {[
          { text: "Dashboard", icon: <DashboardIcon />, path: "/admin/dash" },
          { text: "Events", icon: <EventIcon />, path: "/settings" },
          {
            text: "Gate Pass Records",
            icon: <GroupIcon />,
            path: "/userList",
          },
          {
            text: "Re-Download Passes",
            icon: <GroupIcon />,
            path: "/redownload",
          },
          {
            text: "VIP Events",
            icon: <GroupIcon />,
            path: "/vipEvents",
          },
          {
            text: "Unique Event",
            icon: <GroupIcon />,
            path: "/unique/settings",
          },
          {
            text: "Unique Users",
            icon: <GroupIcon />,
            path: "/unique/userList",
          },
          {
            text: "Scanner",
            icon: <EventIcon />,
            path: "/scanner",
          },
          { text: "Logout", icon: <ExitToAppIcon />, path: "/" },
        ].map((item, index) => (
          <ListItem button key={index} component={Link} to={item.path}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            {drawerOpen && <ListItemText primary={item.text} />}
          </ListItem>
        ))}
      </List>
    </div>
  );
  // console.log(drawerOpen);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)` },
          ml: { sm: `${drawerOpen ? drawerWidth : 0}px` },
          transition: "width 0.3s, ml 0.3s",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={handleDrawerCollapse}
            sx={{ ml: "auto", display: { sm: "block", xs: "none" } }}
          >
            {drawerOpen ? <ExpandMoreIcon /> : <MenuIcon />}
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
          transition: "width 0.3s",
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerOpen ? drawerWidth : 80,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1, // Ensure no padding
          width: { sm: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)` },
          transition: "width 0.3s",
          // ml: { sm: `${drawerOpen ? drawerWidth : 0}px` },
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout;
